var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner-wrapper',{attrs:{"wrapperText":_vm.wrapperText}}),_c('Details',{attrs:{"id":_vm.$route.query.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }